module.exports = __webpack_public_path__ + "static/media/newLock.2468d91b.svg";